module.exports = __webpack_public_path__ + "img/box.d422b1f1.svg";